/**
 * Zondela Traveler Reviews
 * Builds a seamless, infinite vertical auto-scrolling testimonial carousel.
 * - Clones the rendered review track so the loop has no visible jump.
 * - Pauses on hover (handled mainly via CSS, JS adds touch support).
 * - Disabled inside the theme editor while a block is being edited so
 *   merchants can interact with their content.
 */
(function () {
  function initSection(section) {
    var scroller = section.querySelector('[data-zondela-reviews-scroller]');
    var viewport = section.querySelector('[data-zondela-reviews-viewport]');
    var track = section.querySelector('[data-zondela-reviews-track]');

    if (!scroller || !viewport || !track) return;
    if (viewport.dataset.zondelaInitialized === 'true') return;

    var cards = track.querySelectorAll('.zondela-review-card');
    if (!cards.length) return;

    // Duplicate the track so the animation (translateY(-50%)) loops seamlessly.
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-zondela-reviews-track');
    viewport.appendChild(clone);

    viewport.dataset.zondelaInitialized = 'true';

    requestAnimationFrame(function () {
      scroller.classList.add('is-ready');
    });

    // Touch support: pause while the user is touching the carousel.
    scroller.addEventListener('touchstart', function () {
      scroller.classList.add('is-paused');
    }, { passive: true });

    scroller.addEventListener('touchend', function () {
      scroller.classList.remove('is-paused');
    }, { passive: true });
  }

  function init(root) {
    (root || document).querySelectorAll('.zondela-reviews').forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.zondela-reviews');
    if (!section) return;

    // Reset so a re-rendered section gets a fresh clone.
    var viewport = section.querySelector('[data-zondela-reviews-viewport]');
    if (viewport) {
      var clones = viewport.querySelectorAll('[aria-hidden="true"]');
      clones.forEach(function (node) {
        node.remove();
      });
      delete viewport.dataset.zondelaInitialized;
    }

    initSection(section);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target.closest('.zondela-reviews');
    if (section) section.querySelector('[data-zondela-reviews-scroller]').classList.add('is-paused');
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var section = event.target.closest('.zondela-reviews');
    if (section) section.querySelector('[data-zondela-reviews-scroller]').classList.remove('is-paused');
  });
})();
